import React, { useState, useRef, useEffect } from "react"
import { Upload, X, Check, AlertCircle, Loader2, Trash2, Save, AlertTriangle } from "lucide-react"
import { Button, Badge, Input, message, useCRUDController, Row, Col } from "../../ui/ot"
import StatsCard from "../../ui/stats-card"
const ChartTotalHoldings = ({
    propsDataParams = null,
    propsEnableAnimation = true,
    propsCardSize = "md",
    propsContentAlign = "center",
    propsBackgroundColor = "bg-white"
}) => {
    const [data, setData] = useState([
        {
            value: 0,
            label: "館藏總量",
            color: "#1976d2",
            // backgroundColor: "bg-purple-100",
            animationDuration: 2000,
            animationDelay: 0,
        }
    ])
    const [loading, setLoading] = useState(false)
    const dataController = useCRUDController({ apiRoute: "/koha/report/item/total" })
    const getData = () => {
        dataController.getData({
            ...propsDataParams
        }).then((response) => {
            console.log({
                response
            })
            if (!!response) {
                setData([{
                    value: response?.item_total_number,
                    label: "館藏總量",
                    color: "#1976d2",
                    // backgroundColor: "bg-purple-100",
                    animationDuration: 2000,
                    animationDelay: 0,
                }])
            }
        })
    }
useEffect(() => {
    getData()
}, [propsDataParams])


return (<Row>
    <Col span={24}>
        <StatsCard
            layout="horizontal"
            stats={data}
            enableAnimation={propsEnableAnimation}
            isLoading={loading}
            loadingDuration={1500}
            size={propsCardSize}
            contentAlign={propsContentAlign}
            backgroundColor={propsBackgroundColor}
            connection={'separated'}
            columnsPerRow={1}
        />
    </Col>
</Row>)
}
export { ChartTotalHoldings }